export default function toLocaleDateFormat(
  date: string | Date,
  locale: string,
  format = 'dddd, DD MMMM YYYY  (HH:mm a)',
) {
  const formattedDate = useDateFormat(date, format, {
    locales: locale,
  })

  return formattedDate.value
}
